
export default function Services() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Dakwerken',
      description: 'Hellende daken en platte daken. Van dakpannen plaatsen tot EPDM dakbedekking.',
      features: ['Hellende daken', 'Platte daken', 'Dakpannen', 'EPDM dakbedekking', 'Dakgoten']
    },
    {
      icon: 'ri-temp-cold-line',
      title: 'Zolder Isolatie',
      description: 'Professionele isolatie van uw zolder voor optimale energiebesparing.',
      features: ['Spuitisolatie', 'Glaswol isolatie', 'PUR isolatie', 'Dakisolatie', 'Vloerisolatie']
    },
    {
      icon: 'ri-layout-masonry-line',
      title: 'Gyproc & Bezetting',
      description: 'Gyproc werken en kleine bezettingen voor binnenmuren en plafonds.',
      features: ['Gyproc wanden', 'Verlaagde plafonds', 'Stucwerk', 'Afwerking', 'Scheidingswanden']
    },
    {
      icon: 'ri-tools-line',
      title: 'Loodgieterij',
      description: 'Complete loodgietersdiensten voor uw woning of bedrijf.',
      features: ['Sanitair', 'Waterleidingen', 'CV-ketel', 'Badkamer', 'Herstellingen']
    }
  ];

  return (
    <section id="diensten" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Wat kunnen we voor u doen?
          </h2>
          <p className="text-base text-gray-600 max-w-3xl mx-auto">
            Van dakwerken tot loodgieterij, wij bieden een compleet gamma aan diensten voor uw woning of bedrijfspand.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="text-center group cursor-pointer"
            >
              <div className="w-20 h-20 mx-auto mb-6 rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center group-hover:border-blue-600 transition-colors">
                <i className={`${service.icon} text-3xl text-gray-400 group-hover:text-blue-600 transition-colors`}></i>
              </div>
              
              <h3 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                {service.title}
              </h3>
              
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="text-sm text-gray-500">
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
